import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { X, AlertCircle, AlertTriangle, Info, CheckCircle } from 'react-feather';
import { useSnackbar, SnackbarContent } from 'notistack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Box from '@mui/material/Box';

import { VpIcon } from './';

const IconMap = {
  error: AlertCircle,
  success: CheckCircle,
  info: Info,
  warning: AlertTriangle
};

export const VpSnackbar = forwardRef(
  ({ id, message = '', title = '', severity = '', disableClose = false }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const IconComponent = IconMap[severity];

    const onClick = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const hasTitle = !!title;

    return (
      <SnackbarContent ref={ref}>
        <Card
          sx={{
            border: 1,
            borderColor: 'vpColors.greyLight'
          }}
        >
          <CardActions
            sx={{
              display: 'grid',
              gridAutoFlow: 'column',
              gap: '10px'
            }}
          >
            <VpIcon
              sx={{
                alignSelf: hasTitle ? 'start' : 'center',
                ml: '8px', // matches extra padding on icon button
                mt: hasTitle ? '3px' : 0,
                fontSize: '16px',
                color: `${severity}.main`
              }}
            >
              <IconComponent />
            </VpIcon>
            <Box
              sx={{
                display: 'grid',
                paddingRight: '20px',
                maxWidth: '400px'
              }}
            >
              {title && <Typography sx={{ fontWeight: 500 }}>{title}</Typography>}
              <Typography>{message}</Typography>
            </Box>
            {!disableClose && (
              <IconButton onClick={onClick}>
                <VpIcon>
                  <X />
                </VpIcon>
              </IconButton>
            )}
          </CardActions>
        </Card>
      </SnackbarContent>
    );
  }
);

VpSnackbar.propTypes = {
  id: PropTypes.number,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
  disableClose: PropTypes.bool,
  severity: PropTypes.oneOf(['error', 'success', 'warning', 'info'])
};

// react will show displayName in console if errors occur in component
VpSnackbar.displayName = 'VpSnackbar';

export default VpSnackbar;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpSnackbar.jsx